import GraphicEqIcon from '@material-ui/icons/GraphicEq';
import { QuotedMessage } from '@src/types';
import { getTimeDuration } from '@src/utils/mediaUtils';
import { useState } from 'react';

type ChatMessageAudioQuotedProps = {
  title: React.ReactNode;
  message: QuotedMessage;
};

const ChatMessageAudioQuoted: React.FC<ChatMessageAudioQuotedProps> = ({
  title,
  message,
}) => {
  const [duration, setDuration] = useState(0);
  const audio = new Audio(message.mediaUrl);
  audio.onloadeddata = () => {
    setDuration(audio.duration);
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {title}
      <div className="ChatMessageContentQuoted">
        <GraphicEqIcon style={{ marginRight: 3 }} />
        {getTimeDuration(duration)}
      </div>
    </div>
  );
};

export default ChatMessageAudioQuoted;
